
import Vue from "vue";
import { Pricing, PriceFrequencyType } from "../../models/payment/pricing";
import { PaymentService } from "../../services/payment-service";
import { Plan } from "../../utils/payments/plan";
import AppAllPriceItems from "./AllPriceItems.vue";
//import AppLifeTimeToggle from "./LifeTimeToggle.vue";
import { AuthService } from "../../services/auth-service";
import { HttpError } from "@/utils/services/http-error";
import { CompanyService } from "@/services/company-service";
import { Tier } from "@/utils/payments/tiers";

export default Vue.extend({
	data() {
		return {
			pricing: null as Pricing | null,
			selectedFrequencyType: PriceFrequencyType.YEAR,
			currentPlan: new Plan({tier: AuthService.wfCompany.Tier}),
			hasNoPlan: false,
			hasSubscription: true
		};
	},
	computed: {
		showFrequencySwitch(): boolean {
			return false; //AuthService.wfCompany.IsDemo;
		},
		isOwner():boolean{
			if (!AuthService.wfUser) return false;
			return AuthService.wfUser.ID == AuthService.wfCompany.OwnerID;
		},
		showCreateSubscriptionInfo(): boolean {
			if(AuthService.wfCompany.Tier == Tier.FREE) return false;
			if (AuthService.wfCompany.isPermanentlyActive()) return false;
			if (this.hasSubscription) return false;
			if (AuthService.wfCompany.IsDemo) return false;
			return true;
		},
		showPricing(){
			return ((AuthService.wfCompany.Tier < Tier.ENTERPRISE) || AuthService.wfCompany.IsDemo) && AuthService.wfCompany.FixedRenewalPrice == 0;
		}
	},
	methods: {
		async logout(){
			await AuthService.logout();
		}
	},
	async mounted() {
		this.pricing = await PaymentService.getPricing();
		try {
			if(this.isOwner){
				this.currentPlan = await PaymentService.getCurrentPlan();
				this.selectedFrequencyType = this.currentPlan.paymentFrequency;
				this.selectedFrequencyType = this.selectedFrequencyType == PriceFrequencyType.QUARTER ? PriceFrequencyType.YEAR : this.selectedFrequencyType;
			}
		} catch (err) {
			let e = err as HttpError;
			let ignoredKeys = [
				"MOLLIE_CUSTOMER_ID_REQUIRED",
				"WF_OFFLINE_ID_IS_REQUIRED",
				"ALREADY_HAVE_A_LIFETIME_LICENSE",
				"ERR_NOT_COMPANY_OWNER"
			];

			if (ignoredKeys.indexOf(e.key) != -1 || e.message == "No plan") {
				e.dontShow = true;
			}
			this.hasNoPlan = true;
		}
		try {
			await PaymentService.getActiveSubscription();
			this.hasSubscription = true;
		} catch (err) {
			let e = err as HttpError;
			e.dontShow = true;
			this.hasSubscription = false;
		}
		CompanyService.setVisitedPricingPage();
	},
	components: {
		AppAllPriceItems,
		//AppLifeTimeToggle
	},
	i18nEx: {
		componentPrefix: "components.account"
	}
});
